import { PAGE_SIZE } from '~/features/manage-parties/constants';
import { Party } from '~/features/manage-parties/types';
import { pilot } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';
import { PilotId } from '~/types/PilotId';

interface Request {
  clientId: PilotId;
  isInternal: boolean;
  page?: number;
  pageSize?: number;
}

interface Response {
  count: number;
  next: string;
  previous: Nullable<string>;
  results?: Party[];
}

export const getParties = async ({
  clientId,
  isInternal,
  page,
  pageSize = PAGE_SIZE,
}: Request): Promise<{ count: number; results: Party[] }> => {
  const params = { page, page_size: pageSize, internal: isInternal };
  const response = (await pilot.get(`client/${clientId}/party-lists/`, {
    params,
  })) as Response;

  return {
    results:
      response.results?.map((party) => ({
        id: party.id,
        name: party.name,
        isInternal,
      })) ?? [],
    count: response.count,
  };
};
